<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Consultations Manage</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-1">
          <p-button class="no-margin" type="default" block outline round  @click="openAddModal()"> <i class="fa fa-plus"></i> </p-button>
        </div>
        <div class="col-sm-5"  v-if="pagination">
          <el-select
            class="select-default"
            v-model="pagination.per_page"
            placeholder="Per page"
            @change="changePerPage()"
          >
            <el-option
              class="select-default"
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            :data="tableData"
            border
            style="width: 100%;"
            height="600"
          >
            <el-table-column
              v-for="(column) in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :sortable="column.sortable || false"
              :align="column.align"
              :header-align="column.align"
              v-if="!column.hidden"
              :fixed="column.fixed || false"
              :formatter="column.formatter || null"
            ></el-table-column>
            
            <el-table-column :min-width="200" fixed="right" class-name="td-actions" label="Actions" align="center">

              <template slot-scope="props">
                <!-- <p-button type="info" size="sm" icon @click="handleView(props.$index, props.row)">
                  <i class="fa fa-eye"></i>
                </p-button> -->
                <p-button
                  type="success"
                  size="sm"
                  icon
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  v-if="!props.row.isCritical"
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>

                <!-- <p-button
                  type="success"
                  size="sm"
                  icon
                  @click="handlePayments(props.$index, props.row)"
                >
                  <i class="fa fa-credit-card"></i>
                </p-button> -->

                <p-button
                  v-if="!props.row.isCritical"
                  type="default"
                  size="sm"
                  icon
                  @click="handleDownload(props.$index, props.row)"
                >
                  <i class="fa fa-download"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info"  v-if="pagination">
          <p
            class="category"
          >Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries</p>
        </div>
        <div class="col-sm-6"  v-if="pagination">
          <p-pagination
            class="pull-right"
            v-model="pagination.current_page"
            :per-page="Number.parseInt(pagination.per_page)"
            :total="pagination.total"
            @input="changePage()"
          ></p-pagination>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.add"
      headerClasses="justify-content-center"
      footer-classes="justify-content-center"
      >
      <h5 slot="header" class="modal-title">Consultations Manage</h5>
      <form>
        <div class="row">

          <div class="form-group col-12">
            <label for>Location</label>
            <fg-input
              name="location_id"
              v-model="model.location_id"
              v-validate="modelValidations.location_id"
              :error="getError('location_id')"
            >
              <el-select
                name="location_id"
                :class="!getError('location_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Location"
                v-model="model.location_id"
                filterable
                @change="updatePatientConsultation"
              >
                <el-option
                  v-for="(option, index) in locations"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.location_id} - ${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-12">
            <label for>Patient</label>
            <fg-input
              name="patient_id"
              v-model="model.patient_id"
              v-validate="modelValidations.patient_id"
              :error="getError('patient_id')"
            >
              <el-select
                name="patient_id"
                :class="!getError('patient_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Patient"
                v-model="model.patient_id"
                filterable
                @change="updatePatientConsultation"
              >
                <el-option
                  v-for="(option, index) in patients"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.patient_id} - ${option.name} -  ${option.phone}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-12" v-if="patientConsultation.is_expired">
            <label for>Doctor</label>
            <fg-input
              name="doctor_id"
              v-model="model.doctor_id"
              v-validate="modelValidations.doctor_id"
              :error="getError('doctor_id')"
            >
              <el-select
                name="doctor_id"
                :class="!getError('doctor_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Doctor"
                v-model="model.doctor_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in doctors"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.employee_id} - ${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="col-12" v-if="patientConsultation">
            <div class="alert alert-primary" role="alert" v-if="!patientConsultation.is_expired">
              {{ `Patient has an active plan valid for ` }} <strong>{{ patientConsultation.days }}</strong> {{ ` days.`  }}
            </div>
          </div>          

          <div class="form-group col-6" v-if="patientConsultation.is_expired">
            <label for>Date</label>
            <fg-input
              name="datetime"
              v-model="model.datetime"
              v-validate="modelValidations.datetime"
              :error="getError('datetime')"
            >
              <el-date-picker v-model="model.date" type="date" placeholder="Pick a day" :picker-options="datePickerOptions"></el-date-picker>
            </fg-input>
          </div>

           <div class="form-group col-6" v-if="patientConsultation.is_expired">
            <label for>Amount</label>
            <fg-input
              type="number"
              name="amount"
              v-model="model.amount"
              v-validate="modelValidations.amount"
              placeholder="Consultation Amount"
              :error="getError('amount')"
            >
            </fg-input>
          </div>

          <div class="form-group col-6" v-if="patientConsultation.is_expired">
            <label for>Payment Mode</label>
              <fg-input
              name="mode_of_payment_id"
              v-model="model.mode_of_payment_id"
              v-validate="modelValidations.mode_of_payment_id"
              :error="getError('mode_of_payment_id')"
            >
              <el-select
                name="mode_of_payment_id"
                :class="!getError('mode_of_payment_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Payment Mode"
                v-model="model.mode_of_payment_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in modes"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-6" v-if="patientConsultation.is_expired">
            <label>Transaction ID</label>
            <fg-input type="text" name="transaction_id" v-model="model.transaction_id" v-validate="modelValidations.transaction_id" :error="getError('transaction_id')"></fg-input>
          </div>

        </div>
      </form>
      <template slot="footer" v-if="patientConsultation.is_expired">
        <p-button type="success" @click="validate()">Save Consultation</p-button>
      </template>
    </modal>

  </div>
</template>


<script>
import axios from "axios";
import Vue from "vue";
import { Modal } from "src/components/UIComponents";
import { Progress, Upload, Table, TableColumn, Select, Option, Slider, DatePicker } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
// import users from "../Tables/users.js";
import swal from 'sweetalert2'
import pdf from 'vue-pdf'

import { mapGetters } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Slider);

export default {
  components: {
    [DatePicker.name]: DatePicker,
    PPagination,
    Modal,
    [Upload.name]: Upload,
    [Progress.name]: Progress,
    pdf
  },
  mounted() {
    this.$store.dispatch("fetchConsultations", { per_page: 10, page: 1 });
    this.$store.dispatch("fetchSimplePatientsAll");
    this.$store.dispatch("fetchLocationsAll");
    this.$store.dispatch("fetchDoctorsAll");
    this.$store.dispatch("fetchConsultationFee");
    this.$store.dispatch("fetchModesAll");
  },
  watch: {
      searchQuery: function (val) {
          this.$store.dispatch("fetchConsultations", {
              searchQuery: this.searchQuery,
              per_page: this.pagination.per_page,
              page: this.pagination.current_page
          }); 
      }
  },
  computed: {
    ...mapGetters({
      tableData: "getConsultations",
      pagination: "getPagination",
      doctors: "getDoctors",
      patients: "getPatients",
      locations: "getLocations",
      consultationFee: "getConsultationFee",
      currentUser: "getCurrentUser",
      patientConsultation: "getPatientConsultation",
      modes: "getModes",
    }),
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      // if (!this.searchQuery) {
      //   if(this.locations)
      //   this.pagination.total = this.locations.length;
      //   else
      //   this.pagination.total = 0
      //   return this.pagedData;
      // }
      // let result = this.locations.filter(row => {
      //   let isIncluded = false;
      //   for (let key of this.propsToSearch) {
      //     let rowValue = row[key].toString();
      //     if (rowValue.includes && rowValue.includes(this.searchQuery)) {
      //       isIncluded = true;
      //     }
      //   }
      //   return isIncluded;
      // });
      // this.pagination.total = result.length;
      // return result.slice(this.from, this.to);
    }
  },
  data() {
    return {
      scope: 'add',
      modals: {
        add: false,
        edit: false
      },
      datePickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        },
        {
          text: 'Tomorrow',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 1)
            picker.$emit('pick', date)
          }
        },
        {
          text: 'Next week',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      perPageOptions: ["10", "30", "50", "100", "250", "500"],
      searchQuery: "",
      propsToSearch: [
        "title", "desc", "date"
      ],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 80,
          hidden: true,
          align: "center",
          fixed: "left"
        },
        {
          prop: "patient.patient_id",
          label: "PAT ID",
          minWidth: 200,
          sortable: true,
          align: "center",
          fixed: "left"
        },
        {
          prop: "patient.name",
          label: "PAT Name",
          minWidth: 250,
          sortable: true,
          align: "left",
          fixed: "left"
        },
        {
          prop: "doctor.employee_id",
          label: "DOC ID",
          minWidth: 200,
          sortable: true,
          align: "center"
        },
        {
          prop: "doctor.name",
          label: "DOC Name",
          minWidth: 250,
          sortable: true,
          align: "left"
        },
        {
          prop: "location.location_id",
          label: "LOC ID",
          minWidth: 200,
          sortable: true,
          align: "center"
        },
        {
          prop: "location.name",
          label: "LOC Name",
          minWidth: 250,
          sortable: true,
          align: "left"
        },
        {
          prop: "amount",
          label: "Amount",
          minWidth: 200,
          fixed: false,
          sortable: true,
          align: "right"
        },
        {
          prop: "date",
          label: "Date",
          minWidth: 200,
          fixed: false,
          sortable: true,
          align: "center",
          formatter: function(row, column, cellValue, index){
            var d = new Date(row.date);
            var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
            return  d.toLocaleDateString('en-US', options); 
          }
        },
        {
          prop: "payments",
          label: "Mode",
          minWidth: 200,
          fixed: false,
          sortable: true,
          align: "center",
          formatter: function(row, column, cellValue, index){
            return (cellValue.length > 0) ? cellValue[0].mode_of_payment.name : '--';
            // return cellValue[0].mode_of_payment.name
          }
        },
        {
          prop: "payments",
          label: "Txn ID",
          minWidth: 200,
          fixed: false,
          sortable: true,
          align: "center",
          formatter: function(row, column, cellValue, index){
            return (cellValue.length > 0) ? cellValue[0].transaction_id : '--';
            // return cellValue[0].mode_of_payment.name
          }
        }
      ],
      model: {
        id: null,
        location_id: null,
        patient_id: null,
        doctor_id: null,
        amount: null,
        date: null,
        mode_of_payment_id: null,
        transaction_id: null
      },
      modelValidations: {
        amount: {
          required: false
        },
        patient_id: {
          required: true
        },
        location_id: {
          required: true
        },
        doctor_id: {
          required: true
        },
        date: {
          required: true
        },
        mode_of_payment_id: {
          required: true
        },
        transaction_id: {
          required: true
        },
      }
    };
  },
  methods: {
    updatePatientConsultation(){
      if(this.model.patient_id)
      this.$store.dispatch("checkConsultation", {
        patient_id: this.model.patient_id,
        location_id: this.model.location_id
      });
    },
    changePerPage() {
      this.$store.dispatch("fetchConsultations", {
        per_page: this.pagination.per_page,
        page: 1, searchQuery : this.searchQuery
      });
    },
    changePage() {
      this.$store.dispatch("fetchConsultations", {
        per_page: this.pagination.per_page,
        page: this.pagination.current_page, searchQuery : this.searchQuery
      });
    },
    handleEdit(index, row) {
      this.model.id = row.id;
      this.model.location_id = row.location.id;
      this.model.patient_id = row.patient.id;
      this.model.doctor_id = row.doctor.id;
      this.model.amount = row.amount;
      this.model.date = row.date;
      this.scope = 'edit';
      this.updatePatientConsultation();
      this.modals.add = true;
    },
    handleDelete(index, row) {
      swal({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-default btn-fill",
          confirmButtonText: "Delete it!",
          buttonsStyling: false
      })
      .then(result => { this.$store.dispatch("deleteConsultation", row.id); })
      .catch(cancel => { console.log(cancel) });

      // this.$store.dispatch("deleteConsultation", row.id);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.modals.add = false;

          this.model.created_by = this.currentUser.profile_id
          console.log("TCL: validate -> this.model", this.model)
          
          switch(this.scope){
            case 'add'  : this.$store.dispatch("createConsultation", this.model); break;
            case 'edit' : this.$store.dispatch("updateConsultation", this.model); break;
          }
        }
      });
    },
    openAddModal(){
      this.model.id = null;
      this.model.location_id = this.currentUser.location.id;
      this.model.patient_id = null;
      this.model.doctor_id = null;
      this.model.amount = this.consultationFee;
      this.model.date = new Date();
      this.scope = 'add';
      this.modals.add = true;
    },
    handleDownload(index, row) {
        let authToken = JSON.parse(localStorage.getItem('zyro_user_token')).access_token;
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        };

        axios({
          url: `${process.env.VUE_APP_API_URL}/auth/consultationpdf/${row.id}`,
          method: 'GET',
          headers: headers,
          responseType: "blob" // important
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute('download', `consultation-${row.consultation_id}.pdf`);
          document.body.appendChild(link);
          link.click();
        });

      // window.open(`${row.imageURL}`, "_blank", );
    },

  }
};
</script>

<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}

button.no-margin{
  margin: 0;
}

.el-table,
.el-table tr,
.el-table thead th {
  background-color: white !important;
}

.form-group .el-input-number {
  width: 35%;
  outline: none;
}
.el-input--small .el-input__inner {
  border-radius: 50px;
}

.picture-container{
  text-align: center;
}
</style>
